<template>
    <Dialog 
        :visible.sync="isExibirPDF" 
        :contentStyle="dimensaoTela()" 
        :position="position"
        :header="tituloTela" 
        :modal="modal" 
        class="pdf-seplag"  
    >

        <!-- <embed v-if="isPDF"  style="width: 100%; height: 100%" :src="stringPDF">
         <embed v-else :src="stringPDF"> -->
        <iframe id="frame" :src="stringPDF" style="width: 100%; height: 100%"></iframe>
    </Dialog>
</template>

<script>

export default {
    name: "ExibirPDF",
    model: {
        prop: 'exibirPDF',
        event: 'change'
    },
    props: {
        exibirPDF: {
            // Propriedade utilizada para exibir a tela do diálogo do cadastro rápido
            type: Boolean,
            default: true
        },  
        tituloTela: {
            // Título a ser exibido na tela de cadastro rápido
            type: String
        },
        position:{
            // "center", "top", "bottom", "left", "right", "topleft", "topright", "bottomleft" or "bottomright"
            type: String,
            default: "center"
        },
        tamanhoTela: {
            // Tamanho do width a ser dimensionado na tela do cadastro rápido
            type: String
        },
        alturaTela: {
            // Tamanho do width a ser dimensionado na tela do cadastro rápido
            type: String
        },
        visivelFechar: {
            // Informa se tela do cadastro rápido deve ser exibido no modo modal, default=true
            type: Boolean,
            default: true
        },
        modal: {
            // Informa se tela do cadastro rápido deve ser exibido no modo modal, default=true
            type: Boolean, 
            default: true             
        },
        pdfElement:{
          type: String,
          required: true
        }

    },
    data(){
        return{
            stringPDF:null
        }
    },
    methods:{
        carregarDados(){
            let base64 = this.pdfElement
            if(base64.indexOf(',') > 0){
                base64 = this.pdfElement.split(',')[1]
            }

            function base64ToBlob( base64, type = "application/octet-stream" ) {
                const binStr = atob( base64 );
                const len = binStr.length;
                const arr = new Uint8Array(len);
                for (let i = 0; i < len; i++) {
                    arr[ i ] = binStr.charCodeAt( i );
                }
                return new Blob( [ arr ], { type: type } );
            }
            
            const blob = base64ToBlob( base64, 'application/pdf' );
            this.stringPDF = URL.createObjectURL( blob );
        },           
        dimensaoTela(){    
            let tela = ""   
            let tipo = this.pdfElement.split(';')         
            if(this.tamanhoTela && this.tamanhoTela.indexOf(',')> 0){
                let css = this.tamanhoTela.split(',')                
                 tela = tela + `width: ${css[0]}${css[1]};`
            }else if(this.tamanhoTela){
                tela = tela + `width: ${this.tamanhoTela}px;`                     
            }     
                  
            if(tipo[0] == 'data:application/pdf' && this.alturaTela  && this.alturaTela.indexOf(',')> 0){
                let css = this.alturaTela.split(',')  
                tela = tela + `height: ${css[0]}${css[1]};`                 
            }else if(tipo[0] == 'data:application/pdf' && this.alturaTela){
                tela = tela + `height: ${this.alturaTela}px;`                     
            } 
            return tela
        },
        fecharTela(){
            this.isExibirPDF = !this.isExibirPDF
        }
    },
    mounted(){
        this.carregarDados()
    },
    computed: {
        isExibirPDF: {
            get(){
                return this.exibirPDF
            },
            set(){
                // Emite uo evento personalizado para que seja modificado na origem
                this.$emit('change', !this.exibirPDF)
            }
        },
        // stringPDF: {
        //     get(){
                                
        //         function base64ToBlob( base64, type = "application/octet-stream" ) {
        //             const binStr = atob( base64 );
        //             const len = binStr.length;
        //             const arr = new Uint8Array(len);
        //             for (let i = 0; i < len; i++) {
        //                 arr[ i ] = binStr.charCodeAt( i );
        //             }
        //             return new Blob( [ arr ], { type: type } );
        //         }

        //         

        //         if(base64.indexOf(',') > 0){
        //             base64 = res.data.dadosBase64.split(',')[1]
        //         }
                
        //         const blob = base64ToBlob( base64, 'application/pdf' );
        //         console.log(base64)   
        //         return URL.createObjectURL( blob );
        //     }
        // },
        isPDF: {
            get(){
                let tipo = this.pdfElement.split(';')   
                if(tipo.length > 0){
                    if(tipo[0] == 'data:application/pdf'){
                        return true;
                    }else{
                        return false;
                    }
                }else{
                    return true;
                }
            }
        }
    }

}
</script>

<style scoped>
@media screen and (max-width: 40em) {
    .p-dialog-content {
        width: 95% !important;
    }
}
</style>